export enum AvailableLanguages {
  en = 'en',
  it = 'it'
}
